export const cashSalesAssociationState = (record) => {
    const context = record?.sales_context;
    if (!context) return 'missing';
    if (context.confidence === 'ambiguous') return 'ambiguous';
    if (context.cash_sales === null || context.cash_sales === undefined) return 'missing';
    const cashSales = Number(context.cash_sales);
    if (!Number.isFinite(cashSales)) return 'missing';
    return cashSales > 0 ? 'sale' : 'no_sale';
};

export const summarizeCashSalesCoverage = (records = []) => {
    const summary = {
        total: 0,
        associated: 0,
        ambiguous: 0,
        missing: 0,
        percent: 0
    };

    (Array.isArray(records) ? records : []).forEach((record) => {
        summary.total += 1;
        const state = cashSalesAssociationState(record);
        if (state === 'ambiguous') summary.ambiguous += 1;
        else if (state === 'missing') summary.missing += 1;
        else summary.associated += 1;
    });

    summary.percent = summary.total
        ? Number(((summary.associated / summary.total) * 100).toFixed(1))
        : 0;
    return summary;
};
